<!-- PREMIUM GRADIENT BREADCRUMB HEADER -->
<div class="w-full flex align-items-center justify-content-center bg-center bg-cover border-bottom-1 border-primary"
    style="background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #36DEFB 100%); min-height: 20rem;">
    <div class="flex flex-column justify-content-center align-items-center text-center px-4">
        <h1 class="text-white text-5xl md:text-6xl lg:text-7xl font-bold mb-3">Contact Us</h1>
        <ul class="list-none flex align-items-center justify-content-center p-0 m-0">
            <li>
                <a routerLink="/"
                    class="cursor-pointer text-white text-lg md:text-2xl font-light hover:text-primary transition-colors transition-duration-150 no-underline">Home</a>
            </li>
            <li class="mx-2">
                <i class="pi pi-angle-double-right text-white text-lg md:text-2xl font-light"></i>
            </li>
            <li>
                <span class="text-primary text-lg md:text-2xl font-light">Contact Us</span>
            </li>
        </ul>
    </div>
</div>

<section class="bg-white py-8 relative overflow-hidden" data-prerender>
    <!-- Subtle Background Elements -->
    <div class="absolute top-0 right-0 w-30rem h-30rem bg-primary-alpha-5 border-circle blur-3xl -mr-8 -mt-8 z-0"></div>
    <div class="absolute bottom-0 left-0 w-20rem h-20rem bg-primary-alpha-5 border-circle blur-3xl -ml-8 -mb-8 z-0">
    </div>

    <div class="mx-auto px-4 md:px-6 lg:px-8 relative z-1" style="max-width: 1800px;">
        <div class="grid shadow-8 border-round-3xl overflow-hidden bg-white border-1 border-gray-100">
            <!-- Contact Info - Dark Premium Side -->
            <div class="col-12 lg:col-5 p-0">
                <div class="bg-gray-900 h-full p-6 md:p-8 relative overflow-hidden">
                    <!-- Decorative Gradient -->
                    <div class="absolute top-0 left-0 w-full h-full opacity-20"
                        style="background: radial-gradient(circle at 0% 0%, #36DEFB 0%, transparent 70%);"></div>

                    <div class="relative z-1">
                        <!-- Lottie Animation -->
                        <div class="flex justify-content-center mb-6">
                            <lottie-player src="assets/lottie/contact-us.json" background="transparent" speed="1"
                                style="width: 200px; height: 200px; filter: sepia(100%) hue-rotate(150deg) saturate(300%) brightness(1.1);"
                                loop autoplay>
                            </lottie-player>
                        </div>
                        <span class="text-primary font-bold text-xl block mb-3 uppercase tracking-widest">Connect With
                            Us</span>
                        <h2 class="text-white text-4xl md:text-5xl font-bold mb-6">Let's Start a <span
                                class="text-primary">Conversation</span></h2>
                        <p class="text-gray-400 text-lg line-height-3 mb-8">
                            People write to us about two things: a hosted BMS tenant with the modules they need, and a
                            licence for the Snapcart free edition. Either way an engineer reads it, not a queue, and
                            replies by e-mail within one business day.
                        </p>

                        <div class="flex flex-column gap-6">
                            <div class="flex align-items-start gap-4 group cursor-pointer">
                                <div
                                    class="w-4rem h-4rem bg-white-alpha-10 border-round-2xl flex align-items-center justify-content-center flex-shrink-0 shadow-4 border-1 border-white-alpha-10 group-hover:bg-primary group-hover:border-primary transition-all transition-duration-300">
                                    <i
                                        class="pi pi-map-marker text-primary text-2xl group-hover:text-black transition-colors"></i>
                                </div>
                                <div>
                                    <h3 class="text-white text-xl font-bold mb-2">Visit Our Office</h3>
                                    <p class="text-gray-400 m-0 line-height-3">Plot No. 36, Karuna<br>Pushpavihar, Nadathara<br>Thrissur 680751, Kerala, India</p>
                                </div>
                            </div>

                            <div class="flex align-items-start gap-4 group cursor-pointer">
                                <div
                                    class="w-4rem h-4rem bg-white-alpha-10 border-round-2xl flex align-items-center justify-content-center flex-shrink-0 shadow-4 border-1 border-white-alpha-10 group-hover:bg-primary group-hover:border-primary transition-all transition-duration-300">
                                    <i
                                        class="pi pi-phone text-primary text-2xl group-hover:text-black transition-colors"></i>
                                </div>
                                <div>
                                    <h3 class="text-white text-xl font-bold mb-2">Call Us Directly</h3>
                                    <p class="text-gray-400 m-0 line-height-3"><a href="tel:+919895013318" class="text-gray-400 no-underline hover:text-primary">+91 98950 13318</a><br>Mon - Sat, 9 am - 6 pm IST</p>
                                </div>
                            </div>

                            <div class="flex align-items-start gap-4 group cursor-pointer">
                                <div
                                    class="w-4rem h-4rem bg-white-alpha-10 border-round-2xl flex align-items-center justify-content-center flex-shrink-0 shadow-4 border-1 border-white-alpha-10 group-hover:bg-primary group-hover:border-primary transition-all transition-duration-300">
                                    <i
                                        class="pi pi-envelope text-primary text-2xl group-hover:text-black transition-colors"></i>
                                </div>
                                <div>
                                    <h3 class="text-white text-xl font-bold mb-2">Email Us</h3>
                                    <p class="text-gray-400 m-0 line-height-3">
                                        <a href="mailto:info&#64;eszes.in" class="text-gray-400 no-underline hover:text-primary">info&#64;eszes.in</a></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Contact Form - Clean White Side -->
            <div class="col-12 lg:col-7 p-0">
                <div class="p-6 md:p-8 h-full">
                    <h2 class="text-900 text-4xl font-bold mb-4">Send Us a Message</h2>
                    <p class="text-600 text-lg mb-8">Fill in the form and we reply by e-mail within one business day.
                        For the Snapcart free edition, pick that topic: the reply carries your licence file and sign-in details.</p>

                    <form class="grid" #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm)" novalidate>
                        <div class="col-12 mb-4">
                            <label for="topic" class="text-900 block font-bold mb-2">Topic</label>
                            <select id="topic" name="topic" [(ngModel)]="model.topic"
                                class="w-full p-inputtext bg-gray-50 border-gray-200 text-900 border-round-xl">
                                <option *ngFor="let t of topics" [value]="t.value">{{ t.label }}</option>
                            </select>
                        </div>
                        <div class="col-12 md:col-6 mb-4">
                            <label class="text-900 block font-bold mb-2">Full Name</label>
                            <span class="p-input-icon-left w-full">
                                <i class="pi pi-user text-gray-400"></i>
                                <input type="text" pInputText name="name" [(ngModel)]="model.name" #nameCtrl="ngModel" required placeholder="John Doe"
                                    class="w-full bg-gray-50 border-gray-200 text-900 focus:border-primary border-round-xl">
                            </span>
                            <small *ngIf="nameCtrl.invalid && nameCtrl.touched" class="field-error">Please enter your name.</small>
                        </div>
                        <div class="col-12 md:col-6 mb-4">
                            <label class="text-900 block font-bold mb-2">Email Address</label>
                            <span class="p-input-icon-left w-full">
                                <i class="pi pi-envelope text-gray-400"></i>
                                <input type="email" pInputText name="email" [(ngModel)]="model.email" #emailCtrl="ngModel" required email placeholder="john&#64;example.com"
                                    class="w-full bg-gray-50 border-gray-200 text-900 focus:border-primary border-round-xl">
                            </span>
                            <small *ngIf="emailCtrl.invalid && emailCtrl.touched" class="field-error">Please enter a valid e-mail address.</small>
                        </div>
                        <div class="col-12 md:col-6 mb-4">
                            <label class="text-900 block font-bold mb-2">Company <span class="text-600 font-normal">(optional)</span></label>
                            <span class="p-input-icon-left w-full">
                                <i class="pi pi-building text-gray-400"></i>
                                <input type="text" pInputText name="company" [(ngModel)]="model.company" placeholder="Your company"
                                    class="w-full bg-gray-50 border-gray-200 text-900 focus:border-primary border-round-xl">
                            </span>
                        </div>
                        <ng-container *ngIf="isSnapcart">
                            <div class="col-12 md:col-6 mb-4">
                                <label for="os" class="text-900 block font-bold mb-2">Operating system</label>
                                <select id="os" name="os" [(ngModel)]="model.os" #osCtrl="ngModel" required
                                    class="w-full p-inputtext bg-gray-50 border-gray-200 text-900 border-round-xl">
                                    <option value="">Choose…</option>
                                    <option value="macOS">macOS</option>
                                    <option value="Linux">Linux</option>
                                    <option value="Windows">Windows</option>
                                </select>
                                <small *ngIf="osCtrl.invalid && osCtrl.touched" class="field-error">Please choose the operating system.</small>
                            </div>
                            <div class="col-12 mb-4">
                                <label class="text-900 block font-bold mb-2">MAC address of the computer that will run Snapcart</label>
                                <span class="p-input-icon-left w-full">
                                    <i class="pi pi-desktop text-gray-400"></i>
                                    <input type="text" pInputText name="mac" [(ngModel)]="model.mac" #macCtrl="ngModel" required
                                        pattern="^\s*[0-9A-Fa-f]{2}([:-]?[0-9A-Fa-f]{2}){5}\s*$" placeholder="50:3E:AA:21:C0:40"
                                        class="w-full bg-gray-50 border-gray-200 text-900 focus:border-primary border-round-xl">
                                </span>
                                <small *ngIf="macCtrl.invalid && macCtrl.touched" class="field-error">{{ macCtrl.errors?.['required'] ? 'Please enter the MAC address.' : 'That is not a MAC address: it needs six pairs of hex digits, like 50:3E:AA:21:C0:40 or 50-3E-AA-21-C0-40.' }}</small>
                                <small class="text-600 block mt-2">
                                    <ng-container [ngSwitch]="model.os">
                                        <span *ngSwitchCase="'macOS'">Terminal: <code>ifconfig en0 | grep ether</code>.</span>
                                        <span *ngSwitchCase="'Linux'">Terminal: <code>ip link | grep -m1 link/ether</code>.</span>
                                        <span *ngSwitchCase="'Windows'">Command Prompt: <code>getmac /v</code>.</span>
                                        <span *ngSwitchDefault>macOS: <code>ifconfig en0 | grep ether</code> · Linux: <code>ip link | grep -m1 link/ether</code> · Windows: <code>getmac /v</code>.</span>
                                    </ng-container>
                                    The licence file is bound to this address.
                                </small>
                            </div>
                        </ng-container>
                        <div class="col-12 mb-3">
                            <label class="text-900 block font-bold mb-2">Your Message <span *ngIf="isSnapcart" class="text-600 font-normal">(optional)</span></label>
                            <textarea pInputTextarea name="message" [(ngModel)]="model.message" #messageCtrl="ngModel" [required]="!isSnapcart" rows="5"
                                placeholder="Tell us about your project or inquiry..."
                                class="w-full bg-gray-50 border-gray-200 text-900 focus:border-primary border-round-xl resize-none"></textarea>
                            <small *ngIf="messageCtrl.invalid && messageCtrl.touched" class="field-error">Please enter a message.</small>
                        </div>
                        <div class="col-12">
                            <button pButton type="submit" [label]="isSubmitting ? 'Sending…' : (isSnapcart ? 'Request access' : 'Send Message')"
                                icon="pi pi-send" iconPos="right" [disabled]="isSubmitting"
                                class="p-button-primary p-button-lg p-button-rounded px-8 py-3 font-bold shadow-4 hover:shadow-8 transition-all transition-duration-300 w-full md:w-auto"></button>
                            <p *ngIf="showSuccess" class="text-green-600 font-medium mt-3 mb-0"><i class="pi pi-check-circle mr-2"></i>{{ submittedSnapcart ? 'Thank you. We will e-mail your licence file and sign-in details, usually within one business day.' : 'Thank you. An engineer will reply by e-mail within one business day.' }}</p>
                            <p *ngIf="showInvalid && contactForm.invalid" class="text-red-600 font-medium mt-3 mb-0"><i class="pi pi-exclamation-circle mr-2"></i>Nothing was sent yet: please correct the highlighted fields above.</p>
                            <p *ngIf="showError" class="text-red-600 font-medium mt-3 mb-0"><i class="pi pi-times-circle mr-2"></i>Sorry, that did not go through. Please try again in a minute.</p>
                        </div>
                    </form>
                    <div class="col-12 mt-6">
                        <div class="border-round-2xl overflow-hidden shadow-4 border-1 border-gray-100 relative"
                            style="height: 250px;">
                            <iframe
                                src="https://www.google.com/maps?q=10.516083,76.257444&z=16&output=embed"
                                style="width: 100%; height: 100%; border: 0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Map: Nadathara, Thrissur">
                            </iframe>
                            <div class="absolute top-0 left-0 w-full h-full pointer-events-none shadow-inset-2">
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</section>